import { Checkbox } from '@mui/material';
import React from 'react';
import '../../../styles/ahu-test.css'
import { useTkalDataContext } from '../../../context/tkalData';

interface CheckboxOption {
    value: string;
    icon: JSX.Element;
    checkedIcon: JSX.Element;
}

interface CheckboxGroupProps {
    options: CheckboxOption[];
    defaultValue: string;
    measurementKey: string;
}

const CheckboxGroupSepu = ({ options, defaultValue, measurementKey }: CheckboxGroupProps) => {
    const { sepuTest, setSepuTest } = useTkalDataContext();

    const handleChange = (value: string, key: string) => {
        setSepuTest({
            ...sepuTest,
            "measurements": { ...sepuTest.measurements, [key]: { ...sepuTest.measurements[key], "statusNew": value } }
        })
    }
    return (
        <>
            {options.map((option, idx) => (

                <Checkbox
                    className={`grid-item-icon${idx + 1}`}
                    key={option.value}
                    icon={option.icon}
                    checkedIcon={option.checkedIcon}
                    checked={sepuTest.measurements[measurementKey]?.statusNew === option.value}
                    onChange={() => handleChange(option.value, measurementKey)}
                />
            ))}
        </>
    );
}

export default CheckboxGroupSepu;
